if (!customElements.get('smooth-scroll-nav')) {
  class SmoothScrollNav extends HTMLElement {
    constructor() {
      super();
      this.abortController = null;
      this.links = [];
      this.elementsToObserve = [];
      this.navListItems = [];
      this.handleClick = this.handleClick.bind(this);
      this.markVisibleSection = this.markVisibleSection.bind(this);
    }

    connectedCallback() {
      this.abortController?.abort();
      this.abortController = new AbortController();
      const { signal } = this.abortController;

      this.links = [...this.querySelectorAll('a.scroll-anchor')];
      this.elementsToObserve = this.links
        .map((link) => document.getElementById(link.hash.slice(1)))
        .filter(Boolean);
      this.navListItems = [...this.querySelectorAll('li')];

      this.links.forEach((link) => {
        link.addEventListener('click', this.handleClick, { signal });
      });
      window.addEventListener('scroll', this.markVisibleSection, { signal, passive: true });
      window.addEventListener('resize', this.markVisibleSection, { signal });
      this.markVisibleSection();
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.abortController = null;
    }

    handleClick(event) {
      event.preventDefault();
      const targetId = event.currentTarget.hash.slice(1);
      const targetElement = document.getElementById(targetId);
      if (!targetElement) return;

      const rootStyles = getComputedStyle(document.documentElement);
      const headerHeight = parseFloat(rootStyles.getPropertyValue('--header-height')) || 0;
      const scrollSpacing = parseFloat(rootStyles.getPropertyValue('--space-5')) || 0;
      const currentUrl = window.location.href.split('#')[0];
      const targetPosition =
        targetElement.getBoundingClientRect().top + window.scrollY - headerHeight - scrollSpacing;

      history.pushState(null, '', currentUrl);
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth',
      });
    }

    markVisibleSection() {
      this.navListItems.forEach((item) => item.classList.remove('is-visible'));
      this.links.forEach((link) => link.removeAttribute('aria-current'));

      for (const elementToObserve of this.elementsToObserve) {
        const boundingClientRect = elementToObserve.getBoundingClientRect();
        if (boundingClientRect.top <= window.innerHeight && boundingClientRect.bottom >= 0) {
          const activeLink = this.links.find((link) => link.hash === `#${elementToObserve.id}`);
          activeLink?.parentElement?.classList.add('is-visible');
          activeLink?.setAttribute('aria-current', 'true');
          break;
        }
      }
    }
  }

  customElements.define('smooth-scroll-nav', SmoothScrollNav);
}
